var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-variation-price"},[_c('span',{staticClass:"has-text-success"},[_vm._v(_vm._s(/* "$" + currentVariationPrice + " JMD" */))])])}
var staticRenderFns = []

export { render, staticRenderFns }